import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';

class Radio extends PureComponent {
  constructor(props) {
    super(props);
  }


  render() {
    let {checked, onChange, label} = this.props;

    return <div className='radio-inline'>
      <label>
        <input type='radio' checked={checked} onChange={onChange} />
        {label}
      </label>
    </div>;
  }
}
Radio.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};
Radio.defaultProps = {
  checked: false,
};

export default Radio;
